export const defaultFlags = {
  "upmarket_plan_free_trial.enable": true,
  "surveys.v2.archived.enable": true,
  "surveys.v2.enable": true,
  "surveys.v2.manage.enable": true,
  "insight-lob-filtering": true,
  "view-only-users": true,
  "insight-pricing-adjustments": true
};
